import React from "react";

import Editor from './BTagsEditor'
import EditorWrapper from '../../EditorWrapper'

import Tags from "../../common/Tags";
import EmptyArticle from "../../common/EmptyArticle";

const BTags = props => {
    let article = EmptyArticle();
    const { settings } = props;

    article.link = settings.link;
    article.linkName = settings.linkName;

    return (
        <div>
            <div className={props.classes} {...props.events} >
                <EditorWrapper {...props} editor={Editor} />
                <Tags
                    article={article}
                    {...props}
                />
            </div>
        </div>
    );
};

export default BTags;
